import { render } from "./FeedbackNotification.vue?vue&type=template&id=74411af2&scoped=true"
import script from "./FeedbackNotification.vue?vue&type=script&lang=js"
export * from "./FeedbackNotification.vue?vue&type=script&lang=js"

import "./FeedbackNotification.vue?vue&type=style&index=0&id=74411af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74411af2"]])

export default __exports__